import React from 'react';
import { Container, Typography } from '@pwskills/rachnaui';
import Link from 'next/link';
import RefundPolicy from './RefundPolicy';

const TermsOfService = () => {
  return (
    <Container className="my-8 regular:my-14 terms-service">
      <Typography
        component="h1"
        variant="bold"
        className="text-center text-gray-900 pb-9 regular:!pb-14"
      >
        Terms of Service
      </Typography>
      <Typography component="body-regular" variant="regular">
        These Terms of Service (the &quot;ToS&quot;) applies with respect to the usage of the
        Platform (defined hereinafter) and the services offered by{' '}
        <strong>Physics Wallah Limited</strong> (&quot;
        <strong>PW Skills</strong>
        &quot;, &quot;we&quot;, or &quot;us&quot;), a private limited company incorporated under the
        Companies Act, 2013, as amended and having its registered office at, KLJ Noida one B 8,
        Block B, Industrial Area, Sector 62, Noida, Uttar Pradesh 201309, India. PW Skills conducts
        its business under the brand titled &quot;PW Skills&quot;, These Terms of Service shall
        mutatis mutandis apply to mobile apps, WhatsApp groups, Facebook groups, Instagram pages,
        Facebook pages, email/SMS/phone communications and other communication forums/media hosted
        by PW Skills, which shall be deemed to be part of the Platform (defined hereinafter). Your
        usage of the PW Skills Services (defined hereinafter) is subject to your explicit acceptance
        of these ToS. The terms contained in our privacy policy available at ( &quot;privacy
        policy&quot;), or any other policy of PW Skills related to its Services are incorporated
        into these ToS by this reference. Your acceptance of the same will irrevocably and
        unconditionally bind you to comply with and abide by all the obligations and conditions
        stipulated herein (unless otherwise explicitly made optional). After your initial
        confirmation/consent, you will be assumed to continue consenting to these ToS until you
        explicitly withdraw your consent by notifying PW Skills of the same in writing. If an
        executed agreement exists between You and PW Skills in relation to its Services, any
        deviations from these ToS shall only apply when explicitly agreed in writing between the
        parties to such an agreement. IF YOU DO NOT AGREE TO BE BOUND BY ALL CONDITIONS/CLAUSES
        CAPTURED IN THESE TOS, PLEASE DO NOT USE THE PLATFORM OR SERVICES.
      </Typography>
      <Typography
        component="h3"
        variant="bold"
        className="font-inter !text-gray-850 pt-4 regular:pt-6 pb-3 regular:pb-4"
      >
        Updation of Terms
      </Typography>
      <Typography component="body-regular" variant="regular" className="text-gray-850">
        These ToS may be updated, amended, modified or revised by us from time to time. Each such
        updation or modification to the ToS will be communicated to you via email, through the
        Website or any other medium. Your continued use of the PW Skills Services after any such
        changes shall constitute your consent to such changes. We encourage you to refer to these
        ToS from time to time to ensure that you are aware of any additions, revisions, amendments
        or modifications that we may have made.
      </Typography>
      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4 !text-gray-850"
      >
        Service(s) provided to Users
      </Typography>
      <div className="flex flex-col space-y-2 regular:space-y-4 [&>*]:!text-gray-850">
        <Typography component="body-regular" variant="regular">
          PW Skills allows its users to access various training programs on computer sciences
          designed by PW Skills for undergraduates and professionals, including or any other program
          or application that PW Skills introduces from time to time (hereinafter collectively
          referred to as &quot;<strong>Service(s)</strong>&quot; or &quot;
          <strong>PW Skills Service(s)</strong>&quot; and each of these training programs shall be
          referred to as a &quot;<strong>Program</strong>&quot; and collectively as &quot;
          <strong>Programs</strong>&quot;). PW Skills reserves the right, in its sole discretion, to
          add, change, suspend, or discontinue all or any part of its Services at any time. Your
          continued use of PW Skills Services following the posting of any changes to the same
          (including the addition or removal of features) constitutes your acceptance of those
          changes. Any information you provide to us for the purposes of registering and setting up
          your account (as specified below) shall be considered as accurate, complete and updated.
          You are solely responsible for the activity that occurs on your account (including those
          of others authorised to access and operate your account) and for maintaining the security
          of your account and any information you input. We are not responsible for the accuracy or
          legitimacy of any information, data, or User Data uploaded or posted on the Platform. For
          the purposes of clarity, as long as your account is accessed with the correct login
          credentials and unless you notify us of any unauthorised access, you shall be solely
          responsible for all actions/defaults related to your account.
        </Typography>

        <Typography component="body-regular" variant="regular">
          In consideration of your acceptance of these ToS and if applicable, any subscription
          agreement (or any other similar agreement) executed between you and PW Skills, PW Skills
          grants the User a personal, non- exclusive, non-transferable, non-sublicensable, revocable
          limited license to access and use the Platform and Services, in accordance with the ToS.
        </Typography>
      </div>
      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4 !text-gray-850"
      >
        Registration and Account Integrity
      </Typography>
      <div className="flex flex-col space-y-2 regular:space-y-4 [&>*]:!text-gray-850">
        <Typography component="body-regular" variant="regular">
          As part of the registration process, you will need to accept our ToS, and also provide us
          with your name, your phone number, your email ID and in certain scenarios, contact
          information of your parents/guardian. We would not at any time request you to provide us
          with access to your password, unless you have given us explicit written permission to
          access your account pursuant to a request for assistance or support.
        </Typography>
        <Typography component="body-regular" variant="regular">
          It is your responsibility to ensure that the information you provide is accurate, secure,
          and not misleading. You cannot create an account username and password using (i) the names
          and information of another person; or (ii) using words that are the trademarks or the
          property of another party (including ours); or (iii) words that are vulgar, obscene or in
          any other way inappropriate. You agree and confirm that you will never use another
          User&apos;s account nor provide access to your account to any third- party. You agree and
          acknowledge that you are solely responsible for the activities that occur on your account,
          and you shall keep your account password secure and not share the same with anyone. You
          must notify PW Skills immediately of any breach of security or unauthorized use of your
          account. At no point in time will PW Skills be liable for any losses caused by any
          unauthorized use of your account, and you shall solely be liable for the losses caused to
          PW Skills or others due to such unauthorized use, if any.
        </Typography>
        <Typography component="body-regular" variant="regular">
          You shall be solely responsible for obtaining and maintaining any equipment or ancillary
          services necessary to connect to, access, receive PW Skills Services or use the Platform,
          including, without limitation, hardware devices, software, and other internet, wireless,
          broadband, phone or other mobile communication device connection services. You shall be
          solely responsible for ensuring that such equipment or ancillary services are compatible
          with the Platform, and you shall be responsible for all charges incurred in connection
          with the use of the Platform or PW Skills Services in connection with all such equipment
          and ancillary services.
        </Typography>
      </div>
      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4 !text-gray-850"
      >
        Use of your Information and User Data
      </Typography>
      <div className="flex flex-col space-y-2 regular:space-y-4 [&>*]:!text-gray-850">
        <Typography component="body-regular" variant="regular">
          All User Data that you create, transmit, transfer to us, submit, display or otherwise make
          available while using PW Skills Services, should only be information that you own or have
          the right to use or share (as may be applicable). If you transfer any personally
          identifiable information to us, we will assume that you have informed the person concerned
          and procured the necessary consent for such transfer, sharing, processing and/or using the
          information on the Platform and/or in respect of the Services. We may use the above
          information as per our Privacy Policy and in accordance with applicable laws.
        </Typography>
        <Typography component="body-regular" variant="regular">
          While we make commercially reasonable efforts to ensure that the data stored on our
          servers is persistent and always available to our Users, we will not be responsible in the
          event of failure of the third-party servers or any other factors outside our reasonable
          control, that may cause the User Data to be permanently deleted, irretrievable, or
          temporarily inaccessible.
        </Typography>
      </div>

      <Typography component="h3" variant="bold" className="font-inter py-4 !text-gray-850">
        Third Party Links and Services
      </Typography>
      <Typography component="body-regular" variant="regular" className="text-gray-850">
        We use multiple third-party service providers in order to power and provide you with the PW
        Skills Services. In this process, we share the User Data with some of the third-party
        service providers, as is necessary to enable them to provide the requisite services. We will
        attempt to ensure that all our third- party service providers are bound by and adhere to the
        same obligations of confidentiality and data privacy as we guarantee to you. The Platform
        may include links to any third-party websites. PW Skills has no control over, and assumes no
        responsibility for, the content, privacy policies, or practices of any third-party website.
        By using the Platform, you expressly release PW Skills from any liability arising from your
        use of any third-party website or services.
      </Typography>

      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4 !text-gray-850"
      >
        Rules and Acceptable Usage Policy
      </Typography>
      <div className="flex flex-col space-y-2 regular:space-y-4 [&>*]:!text-gray-850">
        <Typography component="body-regular" variant="regular">
          As a condition of use, you promise not to use PW Skills Services for any purpose that is
          prohibited by these ToS, by law, or other rules or policies implemented by us from time to
          time. The PW Skills Services and PW Skills Content is provided only for your own personal,
          non-commercial use. You agree to notify us immediately in case you observe any other User
          breaching the terms contained herein or any policy associated with the Programs.
        </Typography>
        <Typography component="body-regular" variant="regular">
          While using the Platform, you shall not:
        </Typography>
        <ul className="pl-5 list-disc space-y-0.5 regular:space-y-1 [&>li>p]:!text-gray-850">
          <li>
            <Typography component="body-regular" variant="regular">
              harass any third party including any Users or Customers;
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              create an atmosphere of disharmony, hostility within student groups;
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              create an atmosphere of disharmony, hostility within student groups;
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              share any PW Skills Content (including any study materials or test materials) with
              anybody through any media;
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              share solutions to assignments/test materials pertaining to the Platform.
            </Typography>
          </li>
        </ul>
        <Typography component="body-regular" variant="regular" className="text-gray-850">
          Furthermore, you shall not (directly or indirectly):
        </Typography>
        <ul className="pl-5 list-disc space-y-0.5 regular:space-y-1 [&>li>p]:!text-gray-850">
          <li>
            <Typography component="body-regular" variant="regular">
              take any action that imposes or may impose an unreasonable or disproportionately large
              load on PW Skills&apos;s (or its third party providers&apos;) infrastructure;
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              interfere or attempt to interfere with the proper working of the Platform;
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              bypass any measures we may use to prevent or restrict access to the PW Skills Services
              (or parts thereof);
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              modify, translate, or otherwise create derivative works of any part of the PW Skills
              Services or the Platform; or
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              copy, rent, download, extract, lease, distribute, or transfer any part of the
              Platform, PW Skills Content or any third party User Data, unless PW Skills
              specifically allows you to do so.
            </Typography>
          </li>
        </ul>
      </div>

      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4 !text-gray-850"
      >
        Content Ownership and Copyright Conditions of Access
      </Typography>
      <div className="flex flex-col space-y-2 regular:space-y-4 [&>*]:!text-gray-850">
        <Typography component="body-regular" variant="regular">
          The Platform and the PW Skills Content, including but not limited to all text, graphics,
          user interfaces, visual interfaces, sounds, artwork and computer code are owned and
          controlled by PW Skills and/or its licensors and the design, structure, selection,
          expression and arrangement of such content mentioned hereinabove is protected by
          copyright, patent and trademark laws, and other applicable laws on intellectual property
          rights. We reserve all rights, title, and ownership in and to the Platform and PW Skills
          Content.
        </Typography>
        <Typography component="body-regular" variant="regular">
          PW Skills&apos;s logos, trademarks and service marks that may appear on the Platform,
          including but not limited to &quot;PW Skills&quot;, are the property of PW Skills and are
          protected under applicable laws on intellectual property rights.
        </Typography>
        <Typography component="body-regular" variant="regular">
          Your copying, distributing, displaying, reproducing, modifying, or in any other way using
          of PW Skills Content in any manner not specified in these ToS, will be a violation of
          copyright and other intellectual property rights and PW Skills reserves its rights under
          applicable law accordingly.
        </Typography>
        <Typography component="body-regular" variant="regular">
          You shall, at all times, remain the complete owner and retain all rights and title in and
          to the User Data. This includes assuming liability and responsibility in cases where the
          User Data breaches any conditions of confidentiality, any intellectual property rights, or
          any other third-party rights. By posting any User Data through PW Skills Services, you
          grant PW Skills and its affiliates, a worldwide, non-exclusive, royalty- free,
          irrevocable, sub-licensable and transferable license to use, copy, reformat, modify,
          translate, display, sell, create derivative works and distribute such User Data for or in
          connection with the use of the PW Skills Services.
        </Typography>
      </div>
      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4 !text-gray-850"
      >
        Reviews and Feedback
      </Typography>
      <div className="flex flex-col space-y-2 regular:space-y-4">
        <Typography component="body-regular" variant="regular" className="text-gray-850">
          You agree that we may contact you through telephone, email, SMS, or any other electronic
          means of communication for the purpose of:
        </Typography>
        <ul className="pl-5 list-disc space-y-0.5 regular:space-y-1 [&>li>p]:!text-gray-850">
          <li>
            <Typography component="body-regular" variant="regular">
              Obtaining feedback in relation to the Platform or PW Skills Services; and/or
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Resolving any complaints, information, or queries received from you regarding the
              same.
            </Typography>
          </li>
        </ul>
        <Typography component="body-regular" variant="regular">
          Any feedback provided by you may be used by PW Skills without any restriction or
          obligation to compensate you, and we are under no obligation to keep such feedback
          confidential.
        </Typography>
      </div>

      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4 !text-gray-850"
      >
        Rights and Obligations relating to the Content
      </Typography>
      <div className="flex flex-col space-y-2 regular:space-y-4">
        <Typography component="body-regular" variant="regular" className="text-gray-850">
          You are prohibited from:
        </Typography>
        <ul className="pl-5 list-disc space-y-0.5 regular:space-y-1 [&>li>p]:!text-gray-850">
          <li>
            <Typography component="body-regular" variant="regular">
              violating or attempting to violate the integrity or security of the Platform or any
              content therein;
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              transmitting any information (including messages and hyperlinks) on or through the
              Platform that is disruptive or competitive to the provision of our Services;
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              distributing in any medium, any part of the Platform or the PW Skills Content without
              PW Skills&apos;s prior written authorisation;
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              reproducing, duplicating, copying, selling, reselling or exploiting for any commercial
              purpose any PW Skills Content or any portion thereof, other than as expressly allowed
              under this ToS;
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              using the PW Skills Marks in connection with, or to transmit, any unsolicited
              communications or emails or for any other unauthorised purpose;
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              intentionally submitting on the Platform any incomplete, false or inaccurate
              information;
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              using any engine, software, tool, agent or other device or mechanism (such as spiders,
              robots etc.) to navigate or search the Platform;
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              attempting to decipher, decompile, disassemble, alter, modify or reverse engineer any
              part of the Platform;
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              copying or duplicating in any manner any of the PW Skills Content or other information
              available from the Platform;
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              posting or transmitting, or cause to be posted or transmitted, any communication or
              solicitation or other “phishing”, “pharming” or “whaling” message designed or intended
              to obtain password, account, personal information, or confidential information from
              any other User or any other third party whatsoever;
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              using or launching any automated system, including without limitation, “robots,”
              “spiders,” or “offline readers,” that accesses the Platform in a manner that sends
              more request messages to PW Skills’s servers in a given period of time than a human
              can reasonably produce in the same period by using a conventional on-line web browser;
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              circumventing or disabling any digital rights management, usage rules, or other
              security features of the Platform; or
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              allowing any third party to access the Platform through your account unless PW Skills
              specifically allows you to do so.
            </Typography>
          </li>
        </ul>
        <Typography component="body-regular" variant="regular" className="text-gray-850">
          You shall not host, display, upload, modify, publish, transmit, update or share any
          information/content that:
        </Typography>
        <ul className="pl-5 list-disc space-y-0.5 regular:space-y-1 [&>li>p]:!text-gray-850">
          <li>
            <Typography component="body-regular" variant="regular">
              belongs to another person and to which the User does not have any right;
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              is grossly harmful, harassing, blasphemous, defamatory, obscene, pornographic,
              paedophilic, libellous, invasive of another&apos; privacy, hateful, or racially,
              ethnically objectionable, disparaging, relating or encouraging money laundering or
              gambling, or otherwise unlawful or inappropriate in any manner whatsoever;
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              harm minors in any manner;
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              infringes any patent, trademark, copyright or other proprietary rights;
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              violates any law for the time being in force;
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              deceives or misleads the addressee about the origin of such messages or communicates
              any information which is grossly offensive or menacing in nature;
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              impersonates another person;
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              contains software viruses or any other computer code, files or programs designed to
              interrupt, destroy or limit the functionality of any computer resource;
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              threatens the unity, integrity, defence, security or sovereignty of India, friendly
              relations with foreign states, or public order or causes incitement to the commission
              of any cognisable offence or prevents investigation of any offence or is insulting any
              other nation.
            </Typography>
          </li>
        </ul>

        <Typography component="body-regular" variant="regular">
          You understand that while using the Platform, you may be exposed to User Data pertaining
          to other Users, and that PW Skills is not responsible for such User Data. You further
          understand and acknowledge that you may be exposed to User Data that is inaccurate,
          offensive, indecent, or objectionable, and you agree to waive, and hereby do waive, any
          legal or equitable rights or remedies you have or may have against PW Skills in relation
          thereto.
        </Typography>
        <Typography component="body-regular" variant="regular">
          PW Skills shall, upon obtaining knowledge by itself or been brought to actual knowledge in
          writing or through email about any breach of the above conditions, may temporarily
          suspend/delete your account, impose penalties, or take any other actions that PW Skills
          may deem fit. We shall also be{' '}
          <Link className="text-linkBlue" href="mailto:support@pwskills.com">
            support@pwskills.com
          </Link>{' '}
          entitled to preserve such information and produce such records before governmental and/or
          judicial and/or regulatory authorities for investigation purposes as may be required by
          applicable law.
        </Typography>
        <Typography component="body-regular" variant="regular">
          In your use of the Platform, you will at all times comply with all applicable laws and
          regulations. In case of non-compliance with any applicable laws, rules or regulations, or
          this ToS by a User, we shall have the right to immediately terminate your access or usage
          rights to the Platform and to remove non- compliant User Data from the Platform. PW Skills
          shall not be liable to refund any fees/consideration collected from a Customer in case
          such Customer&apos; access to the Platform is terminated by PW Skills for any reason
          detailed herein.
        </Typography>
        <Typography component="body-regular" variant="regular">
          In the course of your usage of the PW Skills Services, you may post reviews, comments,
          suggestions, ideas, questions and other content, or send any other communications as long
          as the content is not illegal, obscene, threatening, defamatory, invasive of privacy,
          infringing any third party&apos; intellectual property rights, or otherwise injurious to
          third parties or objectionable and does not consist of or contain software viruses,
          political campaigning, commercial solicitation, chain letters, mass mailings or any other
          form of spam. Further, you hereby grant PW Skills a limited, royalty-free, worldwide, non-
          exclusive license to use the User Data (including the contents specified herein) in
          further developing the Platform and for the purpose of its marketing or promotional
          activities.
        </Typography>
      </div>

      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4 !text-gray-850"
      >
        Support
      </Typography>
      <div className="flex flex-col space-y-2 regular:space-y-4">
        <Typography component="body-regular" variant="regular">
          PW Skills offers online support tools. You may access support resources or contact our
          support team by emailing us at{' '}
          <Link className="text-linkBlue" href="mailto:support@pwskills.com">
            support@pwskills.com
          </Link>
          . PW Skills shall use commercially reasonable efforts to respond to your request for
          support, or to fix any problems you may be having, as is applicable. Any suggestions by PW
          Skills to you regarding use of the Platform shall not be construed as a warranty.
        </Typography>
      </div>
      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4 !text-gray-850"
      >
        Termination
      </Typography>
      <div className="flex flex-col space-y-2 regular:space-y-4">
        <Typography component="body-regular" variant="regular">
          PW Skills reserves the right to suspend or terminate your access to the Platform and the
          services with or without notice and to exercise any other remedy available under law, in
          cases where:
        </Typography>
        <ul className="pl-5 list-disc space-y-0.5 regular:space-y-1 [&>li>p]:!text-gray-850">
          <li>
            <Typography component="body-regular" variant="regular">
              you are in breach of any terms and conditions of this ToS;
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              PW Skills is unable to verify or authenticate any information provided to PW Skills by
              you; or
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              PW Skills has reasonable grounds for suspecting any illegal, fraudulent or abusive
              activity on your part.
            </Typography>
          </li>
        </ul>
        <Typography component="body-regular" variant="regular">
          Once temporarily suspended, indefinitely suspended or terminated, you may not continue to
          use the Platform under the same account, a different account or re-register under a new
          account. PW Skills may destroy and/or delete all the data and other information related to
          your account as per its discretion. All provisions of the ToS, which by their nature
          should survive termination, shall survive termination, including without limitation,
          warranty disclaimers, indemnity and limitations of liability.
        </Typography>
      </div>
      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4 !text-gray-850"
      >
        Disclaimer
      </Typography>
      <div className="flex flex-col space-y-2 regular:space-y-4">
        <Typography component="body-regular" variant="regular">
          THE PW SKILLS SERVICES AND THE PW SKILLS CONTENT ARE PROVIDED ON AN “AS IS” AND “AS
          AVAILABLE” BASIS AND ARE WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
          NOT LIMITED TO, THE IMPLIED WARRANTIES OF TITLE, NON-INFRINGEMENT, MERCHANTABILITY AND
          FITNESS FOR A PARTICULAR PURPOSE, AND ANY WARRANTIES IMPLIED BY ANY COURSE OF PERFORMANCE
          OR USAGE OF TRADE, ALL OF WHICH ARE EXPRESSLY DISCLAIMED. PW SKILLS AND ITS DIRECTORS,
          EMPLOYEES, AGENTS, SUPPLIERS, SPONSORS AND PARTNERS DO NOT WARRANT THAT: (A) THE PW SKILLS
          SERVICES AND THE PLATFORM WILL BE SECURE, ERROR-FREE OR AVAILABLE AT ANY PARTICULAR TIME
          OR LOCATION; (B) ANY DEFECTS OR ERRORS WILL BE CORRECTED; (C) ANY CONTENT OR SOFTWARE
          AVAILABLE AT OR THROUGH THE PLATFORM IS FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS; OR
          (D) THE RESULTS OF USING THE PLATFORM WILL MEET YOUR REQUIREMENTS. THE PW SKILLS SERVICES
          MAY BE SUBJECT TO LIMITATIONS, DELAYS, AND OTHER PROBLEMS INHERENT IN THE USE OF THE
          INTERNET AND ELECTRONIC COMMUNICATIONS. PW SKILLS IS NOT RESPONSIBLE FOR ANY DELAYS,
          DELIVERY FAILURES, OR OTHER DAMAGE RESULTING FROM SUCH PROBLEMS. YOUR USE OF THE PLATFORM
          AND THE PW SKILLS SERVICES IS SOLELY AT YOUR OWN RISK.
        </Typography>
        <Typography component="body-regular" variant="regular">
          You will be awarded a certificate of successful completion of a Program (&quot;
          <strong>Program Certificate</strong>&quot;) upon fulfilling the criteria and requirements
          of PW Skills, which PW Skills may update from time to time. The decision to award any such
          Program Certificate or other acknowledgement of successful completion of a Program, would
          be solely at PW Skills&apos;s discretion. PW Skills may choose not to offer any such
          Program Certificate or other acknowledgement of successful completion, for some Programs.
          PW Skills may decide at its sole discretion whether to provide a record concerning a
          Customer&apos;s performance in a Program. The format of any certificate, credential or
          other acknowledgement, and of any performance, provided by PW Skills relating to a Program
          will be determined by PW Skills at its sole discretion and may vary as per the Program.
        </Typography>
        <Typography component="body-regular" variant="regular">
          PW Skills has no obligation to have its services, contents, programs and Certificates to
          be recognized by or affiliated to any educational institution or accreditation
          organization. PW Skills provides education related services through the Platform. The
          Platform or the PW Skills Services MUST NOT be construed as a university. The Users
          understand and acknowledge that PW Skills cannot award certificates which are recognised
          by any regulatory body such as the All India Council for Technical Education or University
          Grants Commission.
        </Typography>
        <Typography component="body-regular" variant="regular">
          It is the sole responsibility of the Customer enrolling into a Program to check the
          accuracy of, and evaluate the suitability and relevance of, the Program elected. The
          enrolment into a Program is non- transferable.
        </Typography>
        <Typography component="body-regular" variant="regular">
          You acknowledge that certain parts of the Platform may be enabled by third-party service
          providers, and you agree to abide by their terms and conditions to the extent such terms
          are applicable to you. PW Skills shall not be responsible for any disruption of its
          Services caused by any such third-party service provider.
        </Typography>
      </div>
      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4 !text-gray-850"
      >
        Indemnification
      </Typography>
      <div className="flex flex-col space-y-2 regular:space-y-4">
        <Typography component="body-regular" variant="regular">
          You shall defend, indemnify, and hold harmless PW Skills, its affiliates, subsidiaries and
          each of its, and its affiliates&apos; and subsidiaries&apos; employees, contractors,
          directors, suppliers and representatives from all liabilities, losses, claims, and
          expenses, including reasonable attorneys&apos; fees, that arise from or relate to (i) your
          use or misuse of, or access to, the Platform and/or PW Skills Services; (ii) your
          violation of the ToS or any applicable law; (iii) your violation of any rights of a third
          party in relation to the usage of the Platform. We reserve the right to assume the
          exclusive defence and control of any matter otherwise subject to indemnification by you,
          in which event you will assist and cooperate with us in connection therewith.
        </Typography>
      </div>
      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4 !text-gray-850"
      >
        Limitation of Liability
      </Typography>
      <div className="flex flex-col space-y-2 regular:space-y-4">
        <Typography component="body-regular" variant="regular">
          TO THE FULLEST EXTENT PERMITTED BY LAW, IN NO EVENT SHALL PW SKILLS (NOR ITS DIRECTORS,
          EMPLOYEES, AGENTS, SPONSORS, PARTNERS, SUPPLIERS, CONTENT PROVIDERS, LICENSORS OR
          RESELLERS,) BE LIABLE UNDER CONTRACT, TORT, STRICT LIABILITY, NEGLIGENCE OR ANY OTHER
          LEGAL OR EQUITABLE THEORY WITH RESPECT TO THE SERVICE (I) FOR ANY LOST PROFITS, DATA LOSS,
          LOSS OF GOODWILL OR OPPORTUNITY, OR SPECIAL, INDIRECT, INCIDENTAL, PUNITIVE, OR
          CONSEQUENTIAL DAMAGES OF ANY KIND WHATSOEVER; OR (II) FOR YOUR RELIANCE ON THE PW SKILLS
          SERVICES; OR (III) FOR ANY DIRECT DAMAGES IN EXCESS (IN THE AGGREGATE) OF ONE THOUSAND
          RUPEES (INR 1,000/-); OR (IV) FOR ANY MATTER BEYOND ITS REASONABLE CONTROL, EVEN IF PW
          SKILLS HAS BEEN ADVISED OF THE POSSIBILITY OF ANY OF THE AFOREMENTIONED DAMAGES.
        </Typography>
      </div>
      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4 !text-gray-850"
      >
        Governing Law
      </Typography>
      <div className="flex flex-col space-y-2 regular:space-y-4">
        <Typography component="body-regular" variant="regular">
          The ToS shall be governed by and construed in accordance with the laws of India without
          regard to the conflict of laws provisions thereof. All claims, differences and disputes
          arising under or in connection with or in relation hereto the Platform, the ToS or any
          transactions entered into on or through the Platform shall be subject to the exclusive
          jurisdiction of the courts at Bengaluru, India and you hereby accede to and accept the
          jurisdiction of such courts.
        </Typography>
      </div>
      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4 !text-gray-850"
      >
        Payments
      </Typography>
      <div className="flex flex-col space-y-2 regular:space-y-4">
        <Typography component="body-regular" variant="regular">
          Unless otherwise expressly agreed in writing by PW Skills, full payment for enrolment and
          participation in a Program is required at the time of registration. To make payment for
          any Program or to purchase any services or products offered by PW Skills through the
          Platform, you must have internet access and a current valid accepted payment method as
          indicated on the Platform (&quot;
          <strong>Payment Method</strong>&quot;). PW Skills does not store any of your credit card
          information or such other information restricted by the Reserve Bank of India (RBI) for
          processing payment and has partnered with payment gateways for the payment towards the
          services. By using a third-party payment provider, you agree to abide by the
          terms/policies of such third-party payment provider. You agree that in case PW
          Skills&apos;s third-party payment provider stores any such information, PW Skills will not
          be responsible for such storage, and it will be solely at your discretion to allow the
          third party to store such information as per its terms/policies. PW Skills shall in no way
          be liable for loss of such information or any loss incurred by you due to the misuse of
          such information and PW Skills shall not be obligated to reimburse you for any such loss
          or to hold you harmless in any manner. You also agree to pay all applicable fees for the
          payments made through the Platform.
        </Typography>
        <Typography component="body-regular" variant="regular">
          PW Skills does not support all payment methods, currencies or locations for payment. All
          applicable taxes are calculated based on the billing information you provide to us at the
          time of enrolment/purchase. Your transactions on the Platform may be subject to foreign
          exchange fees or exchange rates.
        </Typography>
      </div>
      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4 !text-gray-850"
      >
        Pause Feature
      </Typography>
      <Typography component="body-regular" variant="regular">
        Our Programs&apos; pace and workload can be varied by the learners as per their needs. We
        have enabled a “Pause” feature through which a learner enrolled in the new PW Skills
        Programs may opt to pause their program for a maximum of Three (3) months in the entire
        duration of the program. During this pause period, access to previous recordings and doubt
        resolution will be available to the learner. No new lectures will be added during the pause
        period. If a learner opts to pause a program beyond the above- mentioned limit of Three (3)
        months, each additional month of Pause shall be chargeable at an amount determined by PW
        Skills in its sole discretion, and such amount may be updated from time to time, exclusive
        of applicable taxes, and shall be subject to PW Skills&apos;s specific approval.
      </Typography>
      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4 !text-gray-850"
      >
        Policy by NDNC
      </Typography>
      <div className="flex flex-col space-y-2 regular:space-y-4">
        <Typography component="body-regular" variant="regular">
          By using the Website and/or registering yourself at{' '}
          <strong>
            <Link className="text-linkBlue" href="/" /> pwskills.com
          </strong>{' '}
          you authorise us to contact you via email or phone call or sms and offer you our services,
          imparting product knowledge, offer promotional offers running on website &amp; offers
          offered by the associated third parties, for which reasons, personally identifiable
          information may be collected. And irrespective of the fact if also you have registered
          yourself under DND or DNC or NCPR service, you still authorise us to give you a call from
          PW Skills for the above-mentioned purposes till 365 days of your registration with us.
          This Privacy Policy covers PW Skills treatment of personally identifiable information that
          it collects when you are on the PW Skills&apos;s site, and when you use its services. This
          policy also covers PW Skills&apos;s treatment of personally identifiable information that
          PW Skills&#39;s business partner shares with PW Skills. This policy does not apply to the
          certain PW Skills&#39;s products or services, when you visit PW Skills&#39;s pages, and
          when you enter promotions.
        </Typography>
        <Typography component="body-regular" variant="regular">
          PW Skills may also receive personally identifiable information from our business partners.
          When you registered with PW Skills, we ask for your first name, last name, contact no,
          email, Date of Birth and gender. Once you register with PW Skills and sign in to our
          services, you are not anonymous to us. Also during registration, you may be requested to
          register your mobile phone and email id, pager, or other device to receive text messages,
          and other services to your wireless device. By registration you authorise us to send
          sms/email alerts to you for your login details and any other service requirements or some
          advertising messages/emails from us.
        </Typography>
      </div>
      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4"
      >
        Copyright Infringement Notice
      </Typography>
      <div className="flex flex-col space-y-2 regular:space-y-4">
        <Typography component="body-regular" variant="regular">
          If a User believes in good faith that his/her copyright has been infringed, the User may
          provide us with a written communication which contains:
        </Typography>
        <ul className="pl-5 list-disc space-y-0.5 regular:space-y-1 [&>li>p]:!text-gray-850">
          <li>
            <Typography component="body-regular" variant="regular">
              An electronic or physical signature of the person authorized to act on behalf of the
              owner of the copyright interest/work;
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              A description of the copyrighted work that the User claims has been infringed upon;
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              A description of where the material that the User claims is infringing is located on
              the Platform, and any other details identifying the infringing material;
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              The User&apos;s email address, address and telephone number;
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              A statement by the User, made under penalty of perjury, that the information in the
              copyright notice is accurate and that the User is the copyright owner or authorized to
              act on behalf of the copyright owner.
            </Typography>
          </li>
        </ul>
        <Typography component="body-regular" variant="regular">
          The Copyright infringement notice needs to be sent to the following address:
        </Typography>
        <div className="ml-5 flex flex-col space-y-2 regular:space-y-4">
          <Typography component="body-regular" variant="regular">
            Attention: Physics Wallah
          </Typography>
          <Typography component="body-regular" variant="regular">
            Address: KLJ Noida one B 8, Block B, Industrial Area, Sector 62, Noida, Uttar Pradesh
            201309
          </Typography>
          <Typography component="body-regular" variant="regular">
            Email:{' '}
            <Link className="text-linkBlue" href="mailto:support@pwskills.com">
              support@pwskills.com
            </Link>
          </Typography>
        </div>
      </div>
      <RefundPolicy />
      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4 text-gray-850"
      >
        Miscellaneous
      </Typography>
      <div className="flex flex-col space-y-2 regular:space-y-4">
        <ul className="pl-5 list-disc space-y-0.5 regular:space-y-1 [&>li>p]:!text-gray-850">
          <li>
            <Typography component="body-regular" variant="regular">
              If any provision of the ToS is found to be unenforceable or invalid, that provision
              will be limited or eliminated to the minimum extent necessary so that the ToS will
              otherwise remain in full force and effect and enforceable.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Any failure by PW Skills to enforce any right or failure to act with respect to any
              breach by you under the ToS shall not be construed as, or constitute, a continuing
              waiver of such provision, or a waiver of any other breach of or failure to comply with
              any other provision of the ToS, unless any such waiver has been consented to by us in
              writing.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              These ToS is personal to you and is not assignable or transferable by you except with
              PW Skills’s prior written consent. PW Skills may assign, transfer or delegate any of
              its rights and obligations hereunder without your consent.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              No agency, partnership, joint venture, or employment relationship is created as a
              result of the ToS and neither party has any authority of any kind to bind the other in
              any respect in relation to any third party.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              All notices under the ToS will be in writing and will be deemed to have been duly
              given when received, if personally delivered or sent by certified or registered mail,
              return receipt requested; when receipt is electronically confirmed, if transmitted by
              facsimile or e-mail; or two days after it is sent, if sent for next day delivery by
              recognized overnight delivery service.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              PW Skills shall not be liable for failure to perform, or the delay in performance of,
              any of its obligations if, and to the extent that, such failure or delay is caused by
              events substantially beyond its control, including but not limited to acts of God,
              acts of the public enemy or governmental body in its sovereign or contractual
              capacity, war, terrorism, floods, fire, strikes, pandemics, epidemics, civil unrest or
              riots, power outage, and/or unusually severe weather.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              By accepting the ToS through your use of the Platform, you certify and acknowledge
              that you are 18 years of age or older. If you are under the age of 18 or under the
              legal age in your jurisdiction to enter into a binding contract, you must use the
              Platform only under the supervision of a parent or legal guardian who agrees to be
              bound by the ToS. If you are a parent or legal guardian agreeing to this ToS for the
              benefit of an individual below 18 year of age, please be advised that you are fully
              responsible for his/her use of the Platform, including all financial charges and legal
              liability that he/she may incur. By using the Platform, you represent and warrant that
              you have the right, authority, and capacity to enter into this ToS and to abide by all
              of the terms and conditions set forth herein.
            </Typography>
          </li>
        </ul>
      </div>
      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4 text-gray-850"
      >
        Contact Us
      </Typography>
      <Typography component="body-regular" variant="regular">
        In the event you have any queries/complaints regarding usage of the Platform, including but
        not limited to reporting any violation of these Terms of Service, please contact our
        Grievance Officer at{' '}
        <Link className="text-linkBlue" href="mailto:support@pwskills.com">
          support@pwskills.com
        </Link>{' '}
        . The complaints will be redressed in the manner provided under the Information Technology
        Act, 2000 and rules framed thereunder.
      </Typography>
      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4 text-gray-850"
      >
        Definitions
      </Typography>
      <div className="flex flex-col space-y-2 regular:space-y-4 [&>*]:!text-gray-850">
        <Typography component="body-regular" variant="regular">
          The following defined terms having their respective meanings as provided below have been
          used in these ToS:
        </Typography>
        <Typography component="body-regular" variant="regular">
          &quot;<strong>Customer</strong>&quot; refers to any User who has paid and subscribed to
          any of the Programs, which may include execution of a subscription agreement (or any
          similar agreement executed between such User and PW Skills) or compliance with certain
          additional terms by the User in this regard;&quot;
          <strong>Platform</strong>&quot; shall mean the website pwskills.com , and any other
          platform (including chat groups, PW Skills hosted social media forums/pages and webpages)
          which may allow you to access and/or use the PW Skills Services via any other
          device/medium; &quot;<strong>PW Skills Content</strong>&quot; means and includes all
          questionnaires, interview ideas, study/course material in any format, ideas, concepts,
          inventions, systems, platforms, software, interfaces, tools, utilities, templates, forms,
          techniques, design formats, methods, processes, algorithms, know-how, trade secrets, and
          other technologies and information acquired, created, developed or licensed independently
          by us, prior to or outside the scope of these ToS and any improvement, modification,
          extension or other derivative works thereof and all intellectual property rights thereto.
          PW Skills Content excludes all User Data;
        </Typography>
        <Typography component="body-regular" variant="regular">
          &quot;<strong>User Data</strong>&quot; means all electronic data, information, or other
          content submitted or provided by a User to be stored, collected or processed by us in
          connection with such User&apos;s authorised use of the PW Skills Services; “You” or “User”
          shall mean any user of the Platform.
        </Typography>
      </div>
      <div className="mt-14">
        <Typography component="body-regular" variant="bold">
          These Terms of Service constitute an &#39;electronic record&#39; within the meaning of the
          applicable law (including the Information Technology Act, 2000) and is generated by a
          computer system and does not require any physical or digital signatures
        </Typography>
      </div>
    </Container>
  );
};

export default TermsOfService;
